//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Sandbox store
//
//  Copyright:    © 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.7.0
//    001   13.06.25 Sean Flook       IMANN-1812 Initial revision.
//    002   17.12.25 Sean Flook       IMANN-2197 Correctly reset when the sourceType is not street or property.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

import { create } from "zustand";
import { mountStoreDevtool } from "simple-zustand-devtools";

const useSandboxStore = create(
  (set) => ({
    sourceStreet: undefined,
    currentStreet: undefined,
    currentDescriptorRecord: undefined,
    currentEsuRecord: undefined,
    currentHighwayDedicationRecord: undefined,
    currentOneWayExemptionRecord: undefined,
    currentMaintenanceResponsibilityRecord: undefined,
    currentReinstatementCategoryRecord: undefined,
    currentOSSpecialDesignationRecord: undefined,
    currentInterestRecord: undefined,
    currentConstructionRecord: undefined,
    currentSpecialDesignationRecord: undefined,
    currentHWWRecord: undefined,
    currentPRoWRecord: undefined,
    currentStreetNoteRecord: undefined,
    sourceProperty: undefined,
    currentProperty: undefined,
    currentLpiRecord: undefined,
    currentAppCrossRefRecord: undefined,
    currentProvenanceRecord: undefined,
    currentClassificationRecord: undefined,
    currentOrganisationRecord: undefined,
    currentSuccessorCrossRefRecord: undefined,
    currentPropertyNoteRecord: undefined,
    refreshRelated: false,
    saveClicked: false,
    streetTab: 0,
    propertyTab: 0,
    setStore: (store) => set(() => ({ sandbox: store })),
    setSourceStreet: (street) => set(() => ({ sourceStreet: street })),
    setCurrentStreet: (street) => set(() => ({ currentStreet: street })),
    setCurrentDescriptorRecord: (record) => set(() => ({ currentDescriptorRecord: record })),
    setCurrentEsuRecord: (record) => set(() => ({ currentEsuRecord: record })),
    setCurrentHighwayDedicationRecord: (record) => set(() => ({ currentHighwayDedicationRecord: record })),
    setCurrentOneWayExemptionRecord: (record) => set(() => ({ currentOneWayExemptionRecord: record })),
    setCurrentMaintenanceResponsibilityRecord: (record) =>
      set(() => ({ currentMaintenanceResponsibilityRecord: record })),
    setCurrentReinstatementCategoryRecord: (record) => set(() => ({ currentReinstatementCategoryRecord: record })),
    setCurrentOSSpecialDesignationRecord: (record) => set(() => ({ currentOSSpecialDesignationRecord: record })),
    setCurrentInterestRecord: (record) => set(() => ({ currentInterestRecord: record })),
    setCurrentConstructionRecord: (record) => set(() => ({ currentConstructionRecord: record })),
    setCurrentSpecialDesignationRecord: (record) => set(() => ({ currentSpecialDesignationRecord: record })),
    setCurrentHWWRecord: (record) => set(() => ({ currentHWWRecord: record })),
    setCurrentPRoWRecord: (record) => set(() => ({ currentPRoWRecord: record })),
    setCurrentStreetNoteRecord: (record) => set(() => ({ currentStreetNoteRecord: record })),
    setSourceProperty: (property) => set(() => ({ sourceProperty: property })),
    setCurrentProperty: (property) => set(() => ({ currentProperty: property })),
    setCurrentLpiRecord: (record) => set(() => ({ currentLpiRecord: record })),
    setCurrentAppCrossRefRecord: (record) => set(() => ({ currentAppCrossRefRecord: record })),
    setCurrentProvenanceRecord: (record) => set(() => ({ currentProvenanceRecord: record })),
    setCurrentClassificationRecord: (record) => set(() => ({ currentClassificationRecord: record })),
    setCurrentOrganisationRecord: (record) => set(() => ({ currentOrganisationRecord: record })),
    setCurrentSuccessorCrossRefRecord: (record) => set(() => ({ currentSuccessorCrossRefRecord: record })),
    setCurrentPropertyNoteRecord: (record) => set(() => ({ currentPropertyNoteRecord: record })),
    setRefreshRelated: (refresh) => set(() => ({ refreshRelated: refresh })),
    setSaveClicked: (clicked) => set(() => ({ saveClicked: clicked })),
    setStreetTab: (tab) => set(() => ({ streetTab: tab })),
    setPropertyTab: (tab) => set(() => ({ propertyTab: tab })),
    resetSandbox: (sourceType) => {
      if (sourceType === "street") {
        set((state) => ({
          sourceStreet: state.sourceStreet,
          currentStreet: undefined,
          currentDescriptorRecord: undefined,
          currentEsuRecord: undefined,
          currentHighwayDedicationRecord: undefined,
          currentOneWayExemptionRecord: undefined,
          currentMaintenanceResponsibilityRecord: undefined,
          currentReinstatementCategoryRecord: undefined,
          currentOSSpecialDesignationRecord: undefined,
          currentInterestRecord: undefined,
          currentConstructionRecord: undefined,
          currentSpecialDesignationRecord: undefined,
          currentHWWRecord: undefined,
          currentPRoWRecord: undefined,
          currentStreetNoteRecord: undefined,
          sourceProperty: undefined,
          currentProperty: undefined,
          currentLpiRecord: undefined,
          currentAppCrossRefRecord: undefined,
          currentProvenanceRecord: undefined,
          currentClassificationRecord: undefined,
          currentOrganisationRecord: undefined,
          currentSuccessorCrossRefRecord: undefined,
          currentPropertyNoteRecord: undefined,
          saveClicked: false,
        }));
      } else if (sourceType === "property") {
        set((state) => ({
          sourceStreet: undefined,
          currentStreet: undefined,
          currentDescriptorRecord: undefined,
          currentEsuRecord: undefined,
          currentHighwayDedicationRecord: undefined,
          currentOneWayExemptionRecord: undefined,
          currentMaintenanceResponsibilityRecord: undefined,
          currentReinstatementCategoryRecord: undefined,
          currentOSSpecialDesignationRecord: undefined,
          currentInterestRecord: undefined,
          currentConstructionRecord: undefined,
          currentSpecialDesignationRecord: undefined,
          currentHWWRecord: undefined,
          currentPRoWRecord: undefined,
          currentStreetNoteRecord: undefined,
          sourceProperty: state.sourceProperty,
          currentProperty: undefined,
          currentLpiRecord: undefined,
          currentAppCrossRefRecord: undefined,
          currentProvenanceRecord: undefined,
          currentClassificationRecord: undefined,
          currentOrganisationRecord: undefined,
          currentSuccessorCrossRefRecord: undefined,
          currentPropertyNoteRecord: undefined,
          saveClicked: false,
        }));
      } else {
        set((state) => ({
          sourceStreet: undefined,
          currentStreet: undefined,
          currentDescriptorRecord: undefined,
          currentEsuRecord: undefined,
          currentHighwayDedicationRecord: undefined,
          currentOneWayExemptionRecord: undefined,
          currentMaintenanceResponsibilityRecord: undefined,
          currentReinstatementCategoryRecord: undefined,
          currentOSSpecialDesignationRecord: undefined,
          currentInterestRecord: undefined,
          currentConstructionRecord: undefined,
          currentSpecialDesignationRecord: undefined,
          currentHWWRecord: undefined,
          currentPRoWRecord: undefined,
          currentStreetNoteRecord: undefined,
          sourceProperty: undefined,
          currentProperty: undefined,
          currentLpiRecord: undefined,
          currentAppCrossRefRecord: undefined,
          currentProvenanceRecord: undefined,
          currentClassificationRecord: undefined,
          currentOrganisationRecord: undefined,
          currentSuccessorCrossRefRecord: undefined,
          currentPropertyNoteRecord: undefined,
          saveClicked: false,
        }));
      }
    },
  }),
  {
    name: "sandbox-store", // unique name for the store
  }
);

if (process.env.NODE_ENV === "development") {
  mountStoreDevtool("Sandbox Store", useSandboxStore);
}

export default useSandboxStore;
